export default __webpack_public_path__ + "static/media/-1.19141805.png";